// extracted by mini-css-extract-plugin
module.exports = {"Svg":"icon_Svg__h4GOa","Path":"icon_Path__BFH9Y"};